import { createContext } from 'react'
import '../components/ClassList.css'

export const ClassListContext = createContext();